/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The CreateUserRequest model module.
* @module model/CreateUserRequest
* @version 2020-12-7
*/
export default class CreateUserRequest {
    /**
    * Constructs a new <code>CreateUserRequest</code>.
    * ユーザー登録リクエスト
    * @alias module:model/CreateUserRequest
    * @class
    * @param groupId {Number} グループID
    * @param roleId {Number} ロールID
    * @param name {String} ユーザー名
    * @param loginId {String} ログインID
    * @param password {String} パスワード
    */

    constructor(groupId, roleId, name, loginId, password) {
        
        
        this['groupId'] = groupId;
        this['roleId'] = roleId;
        this['name'] = name;
        this['loginId'] = loginId;
        this['password'] = password;
        
    }

    /**
    * Constructs a <code>CreateUserRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateUserRequest} obj Optional instance to populate.
    * @return {module:model/CreateUserRequest} The populated <code>CreateUserRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateUserRequest();
                        
            
            if (data.hasOwnProperty('groupId')) {
                obj['groupId'] = ApiClient.convertToType(data['groupId'], 'Number');
            }
            if (data.hasOwnProperty('deliveryGroupId')) {
                obj['deliveryGroupId'] = ApiClient.convertToType(data['deliveryGroupId'], 'Number');
            }
            if (data.hasOwnProperty('roleId')) {
                obj['roleId'] = ApiClient.convertToType(data['roleId'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('loginId')) {
                obj['loginId'] = ApiClient.convertToType(data['loginId'], 'String');
            }
            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
            if (data.hasOwnProperty('remarks')) {
                obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String');
            }
        }
        return obj;
    }

    /**
    * グループID
    * @member {Number} groupId
    */
    'groupId' = undefined;
    /**
    * 配送グループID
    * @member {Number} deliveryGroupId
    */
    'deliveryGroupId' = undefined;
    /**
    * ロールID
    * @member {Number} roleId
    */
    'roleId' = undefined;
    /**
    * ユーザー名
    * @member {String} name
    */
    'name' = undefined;
    /**
    * ログインID
    * @member {String} loginId
    */
    'loginId' = undefined;
    /**
    * パスワード
    * @member {String} password
    */
    'password' = undefined;
    /**
    * 備考
    * @member {String} remarks
    */
    'remarks' = undefined;




}
